<script lang="ts">
  // Sommaire de l'étude : rail collant à gauche (écrans larges), boîte repliable au-dessus du
  // contenu sinon. Numérotation identique à celle des titres (lib/toc.ts). Le lien met à jour
  // le hash de l'URL → chaque section est partageable (/francia/#mapa-regiones).
  import { t } from '../lib/i18n.svelte';
  import type { TocItem } from '../lib/toc';

  let { items, active, onGo }: { items: TocItem[]; active: string; onGo: (id: string) => void } = $props();
  let open = $state(false);

  function go(e: MouseEvent, id: string) {
    e.preventDefault();
    open = false;
    onGo(id);
  }
  // La partie parente est « active » si l'une de ses sous-parties l'est.
  const activeParent = $derived(items.find((it) => it.id === active || (it.children || []).some((c) => c.id === active))?.id || '');
</script>

<nav class="toc" class:open aria-label={t('toc.title')}>
  <button class="toc-head" type="button" onclick={() => (open = !open)} aria-expanded={open}>
    <i class="ti ti-list-numbers" aria-hidden="true"></i>{t('toc.title')}
    <i class="ti ti-chevron-down toc-chev" aria-hidden="true"></i>
  </button>
  <ol class="toc-l1">
    {#each items as it, i (it.id)}
      <li class:on={activeParent === it.id}>
        <a href={'#' + it.id} class="toc-a" class:on={active === it.id} onclick={(e) => go(e, it.id)}>
          <span class="toc-n">{i + 1}</span><span class="toc-t">{t(it.key)}</span>
        </a>
        {#if it.children?.length}
          <ol class="toc-l2">
            {#each it.children as ch, j (ch.id)}
              <li>
                <a href={'#' + ch.id} class="toc-a" class:on={active === ch.id} onclick={(e) => go(e, ch.id)}>
                  <span class="toc-n">{i + 1}.{j + 1}</span><span class="toc-t">{t(ch.key)}</span>
                </a>
              </li>
            {/each}
          </ol>
        {/if}
      </li>
    {/each}
  </ol>
</nav>
